import { makeStyles } from '@material-ui/core';

export const useAuthStyles = makeStyles(() => ({
  button: {
    height: '45px'
  },
  alert: {
    marginBottom: '10px'
  },
  listItem: {
    padding: 1
  },
  right: {
    float: 'right'
  },
  helpText: {
    color: 'rgba(0, 0, 0, 0.54)',
    fontSize: '0.75rem',
    marginTop: '3px'
  },
  bold: {
    fontWeight: 600
  }
}));
